import { Component, OnInit } from '@angular/core';
import { ITableColumnHeader } from 'src/app/models/table-column-header';
import { USERS_LIST } from 'src/app/shared/data/users-mock-list';

@Component({
  selector: 'sm-unblock-request',
  templateUrl: './unblock-request.component.html',
  styleUrls: ['./unblock-request.component.scss']
})
export class UnblockRequestComponent implements OnInit {
  usersList: { name: string; location: string; type: string; phone: string; image: string;}[] = [];
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "name"
    },
    {
      columnName: "subject",
      columnProperty: "location"
    },
    {
      columnName: "message",
      columnProperty: "type"
    }
  ];

  constructor() { 
    this.usersList = USERS_LIST;
  }

  ngOnInit(): void {
  }

}
